import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-awards-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['./certificates.component.scss']
})
export class CertificatesComponent implements OnInit {

  certificates: any;
  @Input() month = null;
  download = false;

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {
    //console.log('cert onInit')
    this.getCerts();

  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    //console.log(changes);
    this.getCerts();
  }

  getCerts(){
    //console.log('getCerts preGET');

    this.okService.get("awards/certificates",{month:this.month})
    .subscribe((data) => {

      this.certificates = data.body;

      //console.log('getCerts', data);

    });

  }

  downloadCertificates(){

    this.download = true;

    this.okService.download2("awards/certificatespdf",{month:this.month}).subscribe((data) => {

      this.download = false;

    });
  }

}
